
import { useCallback, useContext } from "react"
import CategoryDropdownContext from "../context/CategoryDropdownContext"
import { useNavigate } from "react-router-dom"
import { cleanName } from "../services/CommonService"

function Subcategory({subcategoryName, categoryName}) {
    const {closeDropdown} = useContext(CategoryDropdownContext)
    const navigate = useNavigate()
    
    const filterArticlesBySubcategory = useCallback(() => {
        navigate('/' + cleanName(categoryName) + '/' + cleanName(subcategoryName))

        if (window.matchMedia("(max-width: 960px)"))
            closeDropdown()
    }, [navigate, closeDropdown, categoryName, subcategoryName])

    return (
        <li className="subcategory" onClick={filterArticlesBySubcategory}>
            {subcategoryName}
        </li>
    )
}

export default Subcategory